import { useEffect, useState } from 'react';
import { logger } from 'src/analytics/KatalLogger';
import { isFeatureEnabled } from 'src/utils/featureFlagUtils';
import { FeatureFlagParameters } from '../utils/types/featureFlags';

export const useFeatureFlag = (parameter: FeatureFlagParameters) => {
  const [state, setState] = useState({
    isEnabled: false,
    isFeatureFlagLoading: true
  });

  useEffect(() => {
    const controller = new AbortController();
    let isLatestRequest = true;

    const checkFeatureFlag = async () => {
      try {
        const enabled = await isFeatureEnabled(parameter);
        // Only update state if this is the latest request and component is mounted
        if (isLatestRequest && !controller.signal.aborted) {
          setState({ isEnabled: enabled, isFeatureFlagLoading: false });
        }
      } catch (error) {
        if (isLatestRequest && !controller.signal.aborted) {
          logger.error(`Error in useFeatureFlag: ${error}`);
          setState({ isEnabled: false, isFeatureFlagLoading: false });
        }
      }
    };

    checkFeatureFlag();

    return () => {
      isLatestRequest = false;
      controller.abort();
    };
  }, [parameter]);

  return state;
};
